import Title from './Title';
export type { TitleProps } from './Title.types';
export { TITLE_SIZE, TITLE_TAG } from './Title.types';

export default Title;
